import React, { useState } from 'react';
import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import { EntityRoutes } from 'routes/constants';
import strings from 'strings';
import FPHtmlViewer from 'UI/components/atoms/FPHtmlViewer';

import { PlainLink } from '../../shared';
import { PRESENTATION_TYPES } from '../constants';
import { DetailPanelLayout } from '../DetailPanelLayout';
import { ListItemIconOption, ListItemOption } from '../styles';

const COPIES = strings.ai.generators.presentationsMaker;

const JOB_ORDERS_PRESENTATION_TYPES_IDS = [
  'call',
  'sms',
  'linkedinJobPost',
  'linkedinInmail',
  'linkedinPrompt'
];

const JOB_ORDERS_PRESENTATION_TYPES = PRESENTATION_TYPES.filter(type => {
  const isEnabled = type?.isEnabled ? type.isEnabled() : true;
  return JOB_ORDERS_PRESENTATION_TYPES_IDS.includes(type.id) && isEnabled;
});

export const JobOrderPresentationTypeSelector = ({
  isEnabled,
  jobOrder,
  onSelectPresentationType
}) => {
  const [selectedPresentationType, setSelectedPresentationType] = useState(null);

  const handlePresentationTypeSelect = id => {
    setSelectedPresentationType(id);
    onSelectPresentationType && onSelectPresentationType(id);
  };

  const { title, address, specialty, company } = jobOrder || {};

  const location = address && `${address?.city?.title}, ${address?.city?.state?.title}`;
  const companyLocation =
    company?.address && `${company?.address?.city?.title}, ${company?.address?.city?.state?.title}`;

  return (
    <DetailPanelLayout
      header={
        <FPHtmlViewer
          content={strings.formatString(COPIES.jobOrders.header, {
            jobOrderTitle: title
          })}
        />
      }
      body={JOB_ORDERS_PRESENTATION_TYPES.map(({ id, Icon, name }) => (
        <Grid item key={id} xs={12}>
          <List>
            <ListItemOption
              button
              disabled={!isEnabled}
              onClick={_event => handlePresentationTypeSelect(id)}
              selected={selectedPresentationType === id}
            >
              <ListItemIconOption>
                <Icon />
              </ListItemIconOption>
              {name}
            </ListItemOption>
          </List>
        </Grid>
      ))}
      footer={
        <>
          <Typography variant="subtitle1">
            {strings.formatString(COPIES.jobOrders.jobOrderToPresent, {
              jobOrderTitle: title
            })}
          </Typography>
          <Typography variant="body2">{jobOrder?.email}</Typography>
          <Typography variant="body2">{location}</Typography>
          <Typography variant="body1">{`${specialty?.industry?.title}: ${specialty?.title}`}</Typography>
          <PlainLink
            itemId={company.id}
            aria-label="Company Name"
            linkProps={{
              type: 'local',
              url: EntityRoutes.CompanyProfile,
              target: '_blank'
            }}
            noWrap
          >
            {company.name}
          </PlainLink>
          {companyLocation && <Typography paragraph={false}>{companyLocation}</Typography>}
        </>
      }
    />
  );
};
